
import { Spin } from 'antd';
import NotFound from 'pages/NotFound';
import { useEffect } from 'react';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { PRIVATE_ROUTES } from 'routes/PrivateRoutes';
import { PUBLIC_ROUTES } from 'routes/PublicRoutes';

const router = createBrowserRouter([...PUBLIC_ROUTES,...PRIVATE_ROUTES, {
  path: '*',
  element: <NotFound />
}]) 


export default function RootRouter() {

  useEffect(() => {
    const ele = document.getElementById('ipl-progress-indicator');
    if (ele) {
      setTimeout(() => {
        // fade out
        ele.classList.add('available');
      }, 500);
      setTimeout(() => {
        // remove from DOM
        ele.remove();
      }, 1500);
    }
    // eslint-disable-next-line
  }, []);
  
return (
    <RouterProvider router={router} fallbackElement={<Spin />} />
  )
}
